export function toDetail(category: string, alias: string, id: number) {
  return `/blog/${encodeURIComponent(category)}/${encodeURIComponent(alias)}-${id}`
}
